import React, { useEffect, useState } from "react";
import "../../css/wb_template.css";
import { apiCall } from "../../services/authServieces";
import ShowSnackBar from "../../components/snackBar";
import TablePagination from "@mui/material/TablePagination";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { saveAs } from "file-saver";
import excel from '../../Assets/images/excel.png'
import search from '../../Assets/images/search.png'
import CustomDateRangePicker from "../../components/DatePickerPastDates";
import { useUIContext } from "../../context";

const MainDealer_report_user = () => {
  const [data, setData] = useState([]);
  const [snackBar, setSnackBar] = useState({ open: false, severity: "", message: "" });
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalTemplates, setTotalTemplates] = useState(0);

  const location = useLocation();

  const [selectedRegion, setSelectedRegion] = useState("");
  const [selectedZone, setSelectedZone] = useState("");
  const [selectedArea, setSelectedArea] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
 
  const [isToDateEnabled, setIsToDateEnabled] = useState(false);

  // Get current date and calculate 2 months ago
  const today = new Date();
  const todayString = today.toISOString().split("T")[0];
  const twoMonthsAgo = new Date(today);
  twoMonthsAgo.setMonth(today.getMonth() - 2);
  const twoMonthsAgoString = twoMonthsAgo.toISOString().split("T")[0];

  // Get region, zone, and area from URL params
  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const region = urlParams.get('region');
    const zone = urlParams.get('zone');
    const area = urlParams.get('area');
    
    if (region) setSelectedRegion(decodeURIComponent(region));
    if (zone) setSelectedZone(decodeURIComponent(zone));
    if (area) setSelectedArea(decodeURIComponent(area));

    // Get dates from location state if available
    if (location.state) {
      if (location.state.fromdate) setIsToDateEnabled(true);
    }
  }, [location]);

  const { dateRanges } = useUIContext();

  // Context से default date
  const dates = dateRanges.mis.map(date => {
    if (!date) return undefined;

    const localDate = new Date(date);
    const year = localDate.getFullYear();
    const month = String(localDate.getMonth() + 1).padStart(2, "0");
    const day = String(localDate.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  });

  const [defaultFrom, defaultTo] = dates;

  const [fromdate, setFromdate] = useState(location.state?.fromdate || defaultFrom);
  const [todate, setTodate] = useState(location.state?.todate || defaultTo);

  // Search with date filter
  const Getdatetodata = async () => {
    if (!fromdate) {
      setSnackBar({
        open: true,
        severity: "warning",
        message: "Please select from date first"
      });
      return;
    }

    setLoading(true);
    try {
      const res = await apiCall({
        endpoint: `api/reports/Search_main_dealer_data?page=${page + 1}&limit=${rowsPerPage}`,
        method: "post",
        payload: { 
          fromdate, 
          todate,
          region: selectedRegion,
          zone: selectedZone,
          area: selectedArea
        }
      });

      if (res?.success) {
        setData(res.data || []);
        setTotalTemplates(res.pagination?.total || res.data.length || 0);
      }
    } catch (error) {
      setSnackBar({
        open: true,
        severity: "error",
        message: error?.response?.data?.message || "An error occurred",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (fromdate && todate && selectedRegion && selectedZone && selectedArea) {
      Getdatetodata();
    }
  }, [fromdate, todate, selectedRegion, selectedZone, selectedArea]);

  // Fetch main dealers data for selected area
const getMainDealersData = async () => {
  if (!selectedRegion || !selectedZone || !selectedArea) return;

  setLoading(true);
  try {
    const res = await apiCall({
      endpoint: "api/reports/get_main_dealers_by_area",
      method: "POST",
      payload: {
        page: page + 1,
        limit: rowsPerPage,
        region: selectedRegion,
        zone: selectedZone,
        area: selectedArea
      }
    });

    if (res?.success) {
      setData(res.data || []);
      setTotalTemplates(res.pagination?.total || res.data.length || 0);
    }
  } catch (error) {
    setSnackBar({
      open: true,
      severity: "error",
      message: error?.response?.data?.message || "An error occurred"
    });
  } finally {
    setLoading(false);
  }
};



  useEffect(() => {
    if (selectedRegion && selectedZone && selectedArea &&!(fromdate && todate )) {
      getMainDealersData();
    }
  }, [page, rowsPerPage, selectedRegion, selectedZone, selectedArea]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Calculate totals for all main dealers
  const calculateTotals = () => {
    return data.reduce(
      (totals, mainDealer) => ({
        totalSend: totals.totalSend + (mainDealer.total_send || 0),
        totalDelivered: totals.totalDelivered + (mainDealer.total_delivered || 0),
        totalFailed: totals.totalFailed + (mainDealer.total_failed || 0),
        totalSeen: totals.totalSeen + (mainDealer.total_seen || 0),
      }),
      {
        totalSend: 0,
        totalDelivered: 0,
        totalFailed: 0,
        totalSeen: 0,
      }
    );
  };

  const totals = calculateTotals();

  // Export data to CSV
  const exportToCSV = () => {
    const header = [
      "Main Dealer",
      "Total Send",
      "Total Delivered", 
      "Total Failed",
      "Total Seen",
      "Sub Total"
    ];

    const rows = data.map(mainDealer => {
      const subTotal =
        (mainDealer.total_send || 0) +
        (mainDealer.total_delivered || 0) +
        (mainDealer.total_failed || 0) +
        (mainDealer.total_seen || 0);

      return [
        mainDealer.main_dealer || "Unknown",
        mainDealer.total_send || 0,
        mainDealer.total_delivered || 0,
        mainDealer.total_failed || 0,
        mainDealer.total_seen || 0,
        subTotal,
      ];
    });

    // Add totals row
    rows.push([
      "Total",
      totals.totalSend,
      totals.totalDelivered,
      totals.totalFailed,
      totals.totalSeen,
      totals.totalSend + totals.totalDelivered + totals.totalFailed + totals.totalSeen,
    ]);

    const csvContent = [
      header.join(","),
      ...rows.map(row => row.join(","))
    ].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, `main_dealer_report_${selectedRegion}_${selectedZone}_${selectedArea}.csv`);
  };

  // Go back to area report
  const handleGoBack = () => {
    navigate(`/admin/area-wise-report?region=${encodeURIComponent(selectedRegion)}&zone=${encodeURIComponent(selectedZone)}`, {
      state: {
        fromdate: fromdate,
        todate: todate,
        region: selectedRegion,
        zone: selectedZone
      }
    });
  };

  // Navigate to dealer report
  const handleNavigateToDealer = (mainDealer) => {
    navigate(`/admin/dealer-wise-report?region=${encodeURIComponent(selectedRegion)}&zone=${encodeURIComponent(selectedZone)}&area=${encodeURIComponent(selectedArea)}&main_dealer=${encodeURIComponent(mainDealer)}`, {
      state: {
        fromdate: fromdate,
        todate: todate,
        region: selectedRegion,
        zone: selectedZone,
        area: selectedArea,
        main_dealer: mainDealer
      }
    });
  };

  return (
    <>
      <div className="Template_id_contian1">
        <h4 className="Head_titleTemplate">
          <div className="DateRangeContain flex items-center ">
            <CustomDateRangePicker rangeKey="mis" />
            <button
              type="button"
              className="SearchDateRange px-4 py-1 bg-blue-500 hover:bg-blue-600 text-white rounded-lg transition"
              onClick={Getdatetodata}
            >
              <img src={search} alt="Search" className="w-5 h-5" />
            </button>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <button 
              onClick={handleGoBack}
              className="btn btn-secondary btn-sm"
              style={{ marginRight: '10px' }}
            >
              ← Back to Areas
            </button>
            Main Dealer Report - {selectedRegion} / {selectedZone} / {selectedArea}
          </div>

          <div onClick={exportToCSV} className="excel_img_btn">
            <img src={excel} alt="export" />
          </div>
        </h4>

        {loading && <div className="loading-spinner">Loading...</div>}

        <div className="Template_id_Card1">
          <div className="table_contain" id="tableContain">
            <table className="Table w-100" id="Table">
              <thead>
                <tr>
                  <th>Main Dealer</th>
                  <th>Total Send</th>
                  <th>Total Delivered</th>
                  <th>Total Failed</th>
                  <th>Total Seen</th>
                  {/* <th>Sub Total</th> */}
                </tr>
              </thead>
              <tbody>
                {data.length === 0 ? (
                  <tr>
                    <td colSpan="6" style={{ textAlign: 'center', padding: '20px' }}>
                      {loading ? 'Loading...' : 'No data available'}
                    </td>
                  </tr>
                ) : (
                  data.map((mainDealer, index) => {
                    const subTotal =
                      (mainDealer.total_send || 0) +
                      (mainDealer.total_delivered || 0) +
                      (mainDealer.total_failed || 0) +
                      (mainDealer.total_seen || 0);

                    return (
                      <tr key={index}>
                        <td>
                          <button
                            className="btn btn-link btn-link1"
                            onClick={() => handleNavigateToDealer(mainDealer.main_dealer || "Unknown")}
                            style={{ textDecoration: 'none', color: '#007bff', cursor: 'pointer' }}
                          >
                            {mainDealer.main_dealer || "Unknown"}
                          </button>
                        </td>
                        <td>{mainDealer.total_send || 0}</td>
                        <td>{mainDealer.total_delivered || 0}</td>
                        <td>{mainDealer.total_failed || 0}</td>
                        <td>{mainDealer.total_seen || 0}</td>
                        {/* <td>{subTotal}</td> */}
                      </tr>
                    );
                  })
                )}

                {data.length > 0 && (
                  <tr className="font-weight-bold">
                    <td><b>Total</b></td>
                    <td><b>{totals.totalSend}</b></td>
                    <td><b>{totals.totalDelivered}</b></td>
                    <td><b>{totals.totalFailed}</b></td>
                    <td><b>{totals.totalSeen}</b></td>
                    {/* <td>
                      <b>
                        {totals.totalSend + 
                         totals.totalDelivered + 
                         totals.totalFailed + 
                         totals.totalSeen}
                      </b>
                    </td> */}
                  </tr>
                )}
              </tbody>
            </table>

            {totalTemplates > 0 && (
              <TablePagination
                component="div"
                count={totalTemplates}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                rowsPerPageOptions={[5, 10, 25, 50]}
              />
            )}
          </div>
        </div>
      </div>
      
      <ShowSnackBar 
        open={snackBar.open} 
        severity={snackBar.severity} 
        message={snackBar.message} 
      />
    </>
  );
};

export default MainDealer_report_user;